import React, { useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';

// import '@style/components/projectForm.scss';
import '../../styles/components/projectForm.scss';

export default (config) => {
  const methods = useForm(config);

  const getFieldWrapped = useCallback(
    (name, options) => (WrappedComp) => {
      const { defaultValue, ...rest } = options;
      const comp = React.cloneElement(WrappedComp, { onChange: console.log });
      return (
        <Controller
          control={methods.control}
          name={name}
          as={comp}
          defaultValue={defaultValue || ''}
          {...rest}
        />
      );
    },
    [methods.control],
  );

  return {
    ...methods,
    getFieldWrapped,
  };
};
